// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"336b8f71","455":"32888b37","977":"221a8905"}[chunkId] + ".chunk.js";
};